import autocomplete from './autocomplete';

var autocompleteObserver = {
    settings: {
        type: '',
        id: '',
        input: ''
    },

    eventParams: {},

    notify( eventName , paramsToNotify = { }) {

        this.eventParams = {
            ...this.settings,
            ...paramsToNotify
        };

        const event = new CustomEvent( eventName , { detail: this.eventParams } );
        document.dispatchEvent(event);
        console.log(eventName);

    },

    setListeners() {

        document.addEventListener('autocompleteObserver::initNewAutocomplete', this.initNewAutocomplete , false);
    },

    initNewAutocomplete(e) {

        this.eventParams = {
            ...this.settings,
            ...e.detail
        };

        let initializatedAutocomplete = autocomplete({ ...this.eventParams });
        const newAutocomplete = new initializatedAutocomplete();
    },

    init() {

        this.initNewAutocomplete = this.initNewAutocomplete.bind(this);
        this.setListeners();
        this.notify('autocompleteObserver::ready');
    }
};

export default autocompleteObserver;


// WEBPACK FOOTER //
// ./cpanel/js/components/autocomplete/modules/autocompleteObserver-functions.js